const removeScript = scriptId => {
  let script = document.getElementById(scriptId);
  if (script) {
    script.remove();
  }
};
export default removeScript;
